import { Model } from '@models/model';
import { Paginated } from '@models/paginated';

export class PartnerPayment extends Model {
  idPartnerPayment: number;
  createDate: string;
  paymentType: string;
  paymentStatus: string;
  total: string;
}

export class PartnerPaymentHistory extends Paginated {
  data: Array<PartnerPayment>;
}

export class PartnerPaymentSendCashback extends Model {
  documentType: string;
  name?: string;
  jsonPaymentDetails: string;
  paymentType: string;
}

export enum PaymentStatus {
  REQUESTED = 'REQUESTED',
  ACCEPTED = 'ACCEPTED',
  PAID = 'PAID',
  CANCELLED = 'CANCELLED',
  BLOCKED = 'BLOCKED '
}

export enum LabelPaymentStatus {
  REQUESTED = 'partner_payout_list_payments_status_request',
  ACCEPTED = 'partner_payout_list_payments_status_accepted',
  PAID = 'partner_payout_list_payments_status_payed',
  CANCELLED = 'partner_payout_list_payments_status_deleted'
}
